import type { HITLConfig } from '../../tool-config-types';

const DISPLAY_ONLY_UPDATE_SIGNAL_FIELDS = new Set(['title']);

export const updateSignalHitlConfig: HITLConfig = {
  extractData: (args: Record<string, unknown>): unknown[] => {
    if (args.signalId) {
      return [args];
    }
    return [];
  },
  wrapEditedData: (data: unknown[]): Record<string, unknown> => {
    const raw = (data[0] ?? {}) as Record<string, unknown>;
    return Object.fromEntries(
      Object.entries(raw).filter(
        ([key]) => !DISPLAY_ONLY_UPDATE_SIGNAL_FIELDS.has(key),
      ),
    );
  },
};
